export const URLS = {
	atendimento_reuniao_sai: '/atendimento/reunioes_realizadas_sai/',
	atendimento_sequoia: '/atendimento/atendimento_sequoia/',
	email_templates: '/clientes/email_templates/',
	send_email: '/clientes/send_email/',
	fundacao_contatos: '/clientes/fundacao_contatos/',
	email_enviados: '/clientes/email_enviados/',
	atendimento_gerenciador_sai: '/atendimento/dashboard_gerencial_fundacao/',
	top_bottom_sai: '/clientes/top_bottom_sai/',
	top_bottom_sap: '/clientes/top_bottom_sap/',
	cliente_filtro_fundacao: '/clientes/filtros_fundacao/',
	informacoes_modal_fundacao: '/atendimento/informacoes_modal_fundacao/',
	informacoes_modal_cliente_pf: '/atendimento/informacoes_modal_cliente_pf/',
	grafico_bolhas_fundacoes: '/atendimento/grafico_bolhas_fundacoes/',
	info_data_politica_fundacao: '/atendimento/info_data_politica_fundacao/',
	atendimento_rapido_fundacao: '/atendimento/atendimento_rapido_fundacao/',
	grafico_tempo_vencimento: '/atendimento/grafico_tempo_vencimento/',
	tabela_clientepf_volatilidade: '/api/tabela_clientepf/detalhes_volatilidade/',
	tabela_clientepf_retorno: '/api/tabela_clientepf/detalhes_retorno/',
	investimentos_clientes_pf_api: '/clientes/investimentos/clientes_pf_api/',
	clientes_todos_user_sap: '/clientes/todos_user_sap/',
	processo_seletivo: '/api/processo_seletivo/',
	api_fundacao: '/api/fundacao/',
	api_clientepf: '/api/clientepf/',
	atendimento_solicitacoes: '/atendimento/solicitacoes/',
	api_notificacao: '/api/notificacao/',
	calendario: '/clientes/calendar/events_api/',
	calendario_auth: '/clientes/auth/microsoft/login/',
	api_tarefa: '/api/tarefas/',
	clientes_calendar_user_api: '/clientes/calendar/users_api',
	clientes_calendar_user_events_api: '/clientes/calendar/user/events/',
	relatorio_politica_agendamento: '/atendimento/relatorio_politica_agendamento/',
	cliente_realocacao: "/clientes/realocacao/",
}
